<template>

    <div class="flex w-full flex-col p-6 sm:p-10 sm:pt-9 xl:px-12 text-sm sm:text-base xl:text-sm text-customGray-text bg-customGray-background/40 transition-all" v-if="discount == 0" :class="!showDiscountBox &&  '!py-6 !sm:py-8'">
        <div class="relative w-full flex flex-col">

            <div class="relative flex w-full cursor-pointer" @click="showDiscountBox = !showDiscountBox">
                <div class="flex-grow">
                    <h4 class="text-black text-sm tracking-[.15rem] uppercase">
                        {{$root.translateString('have_code')}}
                    </h4>
                </div>
                <div class="flex items-center justify-end">
                    <img alt="icona" src="/images/svg/icon-caret.svg" width="10" height="7" class="w-3 h-auto transition-all" :class="showDiscountBox && 'rotate-180'" />
                </div>
            </div>

            <div class="relative flex flex-col w-full" v-if="showDiscountBox">

                <div class="relative w-full pt-6">

                    <span class="relative w-full block pt-3">
                        <span class="w-full flex flex-col relative text-black">
                            <input @focus="validation.discount.state = null" name="name" class="h-7 pt-0 pb-4 px-0 !ring-0 !outline-none !border-0 !border-b !border-customGray-border bg-transparent text-black text-xs sm:text-sm xl:text-xs peer !shadow-none" placeholder=" " type="text" v-model="discountCode" />
                            <label class="-top-5.5 text-customGray-text text-xxs sm:text-xs xl:text-xxs absolute left-0 pointer-events-none peer-focus:!text-xxs peer-focus:sm:!text-xs peer-focus:xl:!text-xxs peer-focus:-top-5.5 peer-focus:!text-customGray-text peer-placeholder-shown:text-xs peer-placeholder-shown:!text-black peer-placeholder-shown:sm:text-sm peer-placeholder-shown:xl:text-xs peer-placeholder-shown:-top-0.5 transition-all w-full text-left">{{ $root.translateString('discount_code') }}</label>
                        </span>
                        <span v-if="validation.discount.state != null" class="text-red-400 px-1.5 text-xs sm:text-sm xl:text-xs flex items-center justify-start mt-2">
                            {{ validation.discount.message }}
                        </span>
                    </span>

                </div>

                <div class="form-submit mt-8 mb-2">
                    <button type="button" @click="applyDiscount" class="relative w-full lg:px-16 py-5 flex items-center bg-customGray-background transition-all !duration-500 mx-auto xl:hover:!rounded-lg group">
                        <span class="absolute w-full h-[calc(100%+1rem)] left-0 top-1/2 -translate-y-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms]"></span>
                        <span class="absolute h-full w-[calc(100%+1rem)] top-0 left-1/2 -translate-x-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms] group-hover:xl:opacity-0"></span>
                        <span class="text-black text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium">
                            {{$root.translateString('apply_code')}}
                        </span>
                    </button>
                </div>
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        props: ['discount', 'lang'],
        data() {
            return {
                discountCode: '',
                showDiscountBox: false,
                validation: {
                    discount: {
                        state: null,
                        message: ''
                    }
                }
            }
        },
        mounted() {
        },
        methods: {
            applyDiscount()
            {
                if(this.discountCode == "") {
                    this.validation.discount.state = true;
                    if(this.lang == 'it') {
                        this.validation.discount.message = 'Devi inserire un codice valido';
                    }else{
                        this.validation.discount.message = 'Your code is invalid';
                    }
                    return
                }

                axios.post('/api/cart/discount', {
                    code: this.discountCode
                })
                    .then(response => {

                        if(!response.data.success) {
                            if(this.lang == "it") {
                                this.validation.discount.message = 'Il codice inserito non è valido';
                            }else{
                                this.validation.discount.message = 'Your code is invalid';
                            }
                            this.validation.discount.state = true;
                        }else{
                            this.$eventHub.$emit('discount.applied');
                        }

                    })
            },
        },
        beforeDestroy() {

        },
    }
</script>
